import type { Chain } from 'viem'

export const megaEth = {
  id: 4326,
  name: 'mega-eth',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.megaeth.build'] },
  },
  blockExplorers: {
    default: { name: 'blockscout', url: 'https://megaeth.blockscout.com' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 1,
    },
  },
} as const satisfies Chain
